import { render, staticRenderFns } from "./dependencies.vue?vue&type=template&id=340c791c&lang=pug"
import script from "./dependencies.vue?vue&type=script&lang=js"
export * from "./dependencies.vue?vue&type=script&lang=js"
import style0 from "./dependencies.vue?vue&type=style&index=0&id=340c791c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports